<template>
  <div class="custom-toast" :class="toast.style"> {{ toast.message }} </div>
</template>

<script>
export default {
    data(){
        return {
            visible: false,
            currentTimeoutId: 0,
        };
    },
    props: {
        toast: {
            type: Object,
            required: true,
            validator(toast) {
                return toast.message && toast.style;
            }
        }
    },
}
</script>

<style scoped>
.custom-toast{
    position: fixed;
    width: fit-content;
    left: 50%;
    transform: translateX(-50%);
    top: 39.25px;
    padding: 3px;
    padding-left: 15px;
    padding-right: 15px;
    border-radius: 30px;
    font-size: 1.05em;
    z-index: 100;
}
.red-style{
    background-color: tomato;
    border: 2px solid rgb(211, 68, 43);
    color: rgb(150, 40, 20);
}
.fit-style{
    background-color: rgb(12, 138, 138);
    color: rgb(1, 68, 68);
    border: 2px solid rgb(12, 92, 92);
}
</style>